import { useMemo } from 'react';

import {
  UseBestPracticeChecksQuery,
  useBestPracticeChecksQuery,
} from 'hooks/queries/security-insights';

import { useActiveClusters } from '../../../_hooks';
import { useClustersOrFixture } from '../../hooks/useClustersOrFixture';

type UseGetBestPracticeChecksProps = {
  filters?: UseBestPracticeChecksQuery;
  enabled?: boolean;
  clusterIds?: string[];
};

export const useGetBestPracticeChecks = ({
  filters = {},
  enabled = true,
  clusterIds: scopedClusterIds,
}: UseGetBestPracticeChecksProps = {}) => {
  const { clusters: _clusters, isLoading: isLoadingClusters } =
    useActiveClusters();
  const { clusters } = useClustersOrFixture(_clusters);

  const clusterIds = useMemo(
    () => scopedClusterIds ?? clusters?.map((cluster) => cluster.id) ?? [],
    [scopedClusterIds, clusters]
  );

  const {
    isLoading: isLoadingChecks,
    checks = [],
    error,
    refetch,
  } = useBestPracticeChecksQuery({
    enabled,
    ...filters,
    clusterIds: filters.clusterIds ?? clusterIds,
  });

  return {
    checks,
    isLoading:
      isLoadingChecks || (scopedClusterIds ? false : isLoadingClusters),
    error,
    refetch,
  };
};
